import React, { useState } from "react";
import {
  Form,
  Input,
  Card,
  Button,
  Select,
  Typography,
  Space,
  Row,
  Col,
  Tooltip,
  Spin,
  DatePicker,
  Collapse,
  Divider,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import { useSearchCustomer } from "../../../hooks/useServerActions";
import { connect } from "react-redux";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import PreviewTable from "../../../component/PreviewTable";
const { Title, Paragraph, Text } = Typography;
const { Option } = Select;
const ContractInformationForm = ({
  userData,
  formData,
  username,
  isEdit,
  isProdDisabled,
  isAccDisabled,
  updateFormData,
  handleSearch,
  customer,
  productOptions,
  custodianOptions,
  form,
  clientId,
  onFinish,
  customerAccOptions,
  accOptLoading,
}) => {
  const isSearchDisabled = !clientId || clientId?.length < 3 ? true : false;
  console.log(customer);
  const onSearch = () => {
    handleSearch(clientId);
  };

  const dataSections = [
    {
      name: "Customer Name",
      labelValue: customer?.displayName,
    },
    {
      name: "Customer ID",
      labelValue: customer?.accountNo,
    },
    {
      name: "Customer Type",
      labelValue: customer?.legalForm?.value || "----",
    },
    {
      name: "Customer Branch",
      labelValue: customer?.officeName || "----",
    },
  ];

  return (
    <div className="form-section">
      {/* <Spin spinning={loading} size="large"> */}
      <h2 style={{ margin: 0, fontSize: "24px" }}>Contract Information</h2>
      <p style={{ marginTop: "5px", color: "#6b7280" }}>
        Retrieve customer info
      </p>

      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{ width: "100%" }}
      >
        <Row>
          {!isEdit && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "80% 17%",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Form.Item
                  rules={[
                    !customer && {
                      required: true,
                      message: "Please enter customer ID",
                    },
                  ]}
                  label={
                    <div>
                      Customer ID{" "}
                      <Tooltip title="Customer Name">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </div>
                  }
                  name={"clientId"}
                >
                  <Input
                    placeholder="Search by customer ID"
                    style={{ height: "44px" }}
                  />
                </Form.Item>
                <Button
                  disabled={isSearchDisabled}
                  onClick={onSearch}
                  style={{
                    border: "1px solid #EAECF0",
                    backgroundColor: !isSearchDisabled ? "#BA24D5" : "#F2F4F7",
                    color: !isSearchDisabled ? "white" : "#98A2B3",
                    marginTop: 5,
                  }}
                >
                  Search
                </Button>
              </div>
            </Col>
          )}
          {customer && (
            <Col span={24} style={{ padding: "0px 8px", marginBottom: 30 }}>
              <PreviewTable data={dataSections} />
            </Col>
          )}

          <Divider style={{ marginBlock: 10 }} />

          <Col span={24}>
            <h3 style={{ margin: 0, marginTop: 30, fontSize: "20px" }}>
              Product Information
            </h3>
            <p style={{ marginTop: "5px", color: "#6b7280" }}>
              Select the product you want to create a contract for.
            </p>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              name="productId"
              rules={[
                {
                  required: true,
                  message: "Please select product",
                },
              ]}
              label={
                <div>
                  Product{" "}
                  <Tooltip>
                    <InfoCircleOutlined title="Product info" color="#667085" />
                  </Tooltip>
                </div>
              }
            >
              <Select
                disabled={isProdDisabled}
                // size="large"
                options={productOptions}
                placeholder={"Select product"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input read-only-select"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              disabled={isAccDisabled}
              rules={[
                {
                  required: true,
                  message: "Please select custodian",
                },
              ]}
              label={
                <Space>
                  Custodian
                  <Tooltip title="Custodian">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"custodian"}
            >
              <Select
                className="custom-input read-only-select"
                disabled={isAccDisabled}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
                placeholder="Custodian"
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={custodianOptions}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              disabled={isAccDisabled}
              rules={[
                {
                  required: true,
                  message: "Please select account",
                },
              ]}
              label={
                <Space>
                  Account Linked
                  <Tooltip title="The Account Linked">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"linkedAccountId"}
            >
              <Select
                className="custom-input read-only-select"
                disabled={isAccDisabled}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
                placeholder={
                  accOptLoading
                    ? "Loading"
                    : customerAccOptions?.length > 0
                    ? "Select Account Linked"
                    : "No account found"
                }
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={customerAccOptions}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Initiated By
                  <Tooltip title="Initialted By">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"initiatedBy"}
            >
              <Input
                className="custom-input of-bold-disable-input"
                placeholder={username}
                style={{ height: "44px" }}
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Date Created
                  <Tooltip title="DateCreated">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"dateCreated"}
            >
              <DatePicker
                disabled
                // size="large"
                style={{ marginBottom: 0, width: "100%" }}
                placeholder="----"
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
                className="bond-date-picker custom-input read-only-select"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {/* </Spin> */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractInformationForm);
// export default ContractInformationForm;
